import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import {
  getProducts as getProductsApi,
  getProductById as getProductByIdApi,
  deleteProducts as deleteProductsApi,
  addNewProduct as addNewProductApi,
  updateProduct as updateProductApi,
  getHotProducts as getHotProductsApi,
} from "../../apiCalls/caller";

export const getProducts = createAsyncThunk(
  "products/getProducts",
  async (data) => {
    toast.dismiss();
    try {
      const response = getProductsApi(data);
      if (response.success == false) {
        toast.error("Error getting products", {
          position: "top-center",
          autoClose: 3000,
        });
      }

      return response;
    } catch (error) {
      toast.error("Error getting products " + error, {
        position: "top-center",
        autoClose: 3000,
      });
      return error;
    }
  }
);

export const getHotProducts = createAsyncThunk(
  "products/getHotProducts",
  async (data) => {
    try {
      return getHotProductsApi(data);
    } catch (error) {
      return error;
    }
  }
);

export const getProductById = createAsyncThunk(
  "products/getProductById",
  async (data) => {
    try {
      return getProductByIdApi(data);
    } catch (error) {
      return error;
    }
  }
);

export const deleteProducts = createAsyncThunk(
  "products/deleteProducts",
  async (product) => {
    toast.dismiss();
    try {
      const response = deleteProductsApi(product);
      toast.success("Product Delete Successfully", { autoClose: 3000 });
      return { product, ...response };
    } catch (error) {
      toast.error("Product Delete Failed", { autoClose: 3000 });
      return error;
    }
  }
);

export const addNewProduct = createAsyncThunk(
  "ecommerce/addNewProduct",
  async (product) => {
    toast.dismiss();
    try {
      const response = addNewProductApi(product);
      const data = await response;
      toast.success("Product Added Successfully", { autoClose: 3000 });
      return data;
    } catch (error) {
      toast.error("Product Added Failed", { autoClose: 3000 });
      return error;
    }
  }
);

export const updateProduct = createAsyncThunk(
  "ecommerce/updateProduct",
  async (product) => {
    toast.dismiss();
    try {
      const response = updateProductApi(product);
      const data = await response;
      toast.success("Product Updateded Successfully", { autoClose: 3000 });
      return data;
    } catch (error) {
      toast.error("Product Updateded Failed", { autoClose: 3000 });
      return error;
    }
  }
);
